import { useState } from "react";
import {
  DyteClock,
  DyteParticipantCount,
  DyteRecordingIndicator,
} from "@dytesdk/react-ui-kit";
import { useDyteMeeting } from "@dytesdk/react-web-core";
import { Loader2, Users } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

interface CallHeaderProps {
  showParticipants: boolean;
  setShowParticipants: (show: boolean) => void;
}

export default function CallHeader({
  showParticipants,
  setShowParticipants,
}: CallHeaderProps) {
  const { meeting } = useDyteMeeting();

  const [recordingState, setRecordingState] = useState<
    "RECORDING" | "PAUSED" | "STOPPING" | "IDLE" | "STARTING"
  >("IDLE");

  let interval = setInterval(() => {
    if (meeting?.recording.recordingState) {
      setRecordingState(meeting?.recording.recordingState);
    }
  }, 1000);

  setTimeout(() => {
    clearInterval(interval);
  }, 15000);

  return (
    <div className="absolute inset-x-0 top-0 z-20 bg-black/30 p-4 backdrop-blur-sm">
      <div className="flex items-center justify-between text-white">
        <div className="flex items-center gap-4">
          <Badge
            variant="secondary"
            className="border-green-600 bg-green-600 text-white"
          >
            <div className="mr-2 size-2 animate-pulse rounded-full bg-white" />
            Live
          </Badge>
          <span className="text-sm">Sales Mentoring Session</span>
          <DyteClock meeting={meeting} className="text-sm text-white/70" />
        </div>
        <div className="flex items-center gap-2">
          <Button
            size="sm"
            variant="outline"
            onClick={() => setShowParticipants(!showParticipants)}
            className="border-white/20 bg-white/10 text-white hover:bg-white/20"
          >
            <Users className="mr-1 size-4" />
            <DyteParticipantCount meeting={meeting} />
          </Button>
          {recordingState === "IDLE" ? (
            <div className="flex items-center justify-center gap-2 text-sm text-gray-300">
              <Loader2 className="mr-2 size-4 animate-spin" />
              Starting recording...
            </div>
          ) : (
            <DyteRecordingIndicator meeting={meeting} />
          )}
        </div>
      </div>
    </div>
  );
}
